<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.1525 19.5C1.66388 19.5 1.5 19.2377 1.5 11.7869C1.5 4.66162 1.57056 4.5 11.9408 4.5C22.311 4.5 22.4999 4.64991 22.4999 12.0187C22.4999 19.3876 22.6388 19.5 12.1525 19.5ZM9.26855 8.45846L9.37781 16.1482L16.1107 12.0211L9.26855 8.45846Z"
    fill="#FF0000"
  />
  <path d="M9.26855 8.45846L9.37781 16.1482L16.1107 12.0211L9.26855 8.45846Z" fill="white" />
</template>
